<template>
    <div class="inline-flex" :class="cssClass">
        <template v-for="(active, icon) in media" :key="icon">
            <svg-icon :type="`${icon.replace('-large','')}`"
                      class="w-18 h-18" :class="[active ? 'text-primary' : 'text-primary-20']"/>
        </template>
    </div>
</template>

<script>
import SvgIcon from "./ui/SvgIcon.vue";

export default {
    components: {
        SvgIcon
    },
    props: {
        media: {
            type: [Array, Object, null],
            required: true
        },
        cssClass: {
            type: String,
            default: ''
        }
    }
}
</script>
